const password = (password) => {
  if (password === null || typeof password !== 'string' || password === '') return false
  if (!/[A-Za-z]/.test(password)) return false
  if (!/\d/.test(password)) return false
  return /[^\w\s]/.test(password)
}

export { password }
